module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "tina-jean-pierre.48717338.png";